module.exports = __webpack_public_path__ + "static/media/BangiExpansion_Mezztop.042e3206.png";